<template>
	<path fill="none" class="stroke-color" stroke="#055A7F" stroke-linecap="round" stroke-width="2" d="M9 6l6.007 5.993L9 18"/>
</template>
<script>
	export default {
		name: 'iconArrowBlue'
	}
</script>
